/**
 * This method properly counts emojis as single characters instead of multibyte
 */
export const graphemeCountCharacters = (input: string) => {
  if (typeof input !== 'string') {
    return 0;
  }
  const segmenterAvailable =
    typeof Intl !== 'undefined' && typeof Intl.Segmenter !== 'undefined';
  if (segmenterAvailable !== false) {
    const segmenter = new Intl.Segmenter('en', { granularity: 'grapheme' });
    return [...segmenter.segment(input)].length;
  }
  return Array.from(input).length;
};
